import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { BiDraftResult } from '@euler/model/bi/draft';
import { BiPalette, BiVizSpec, BiVizType } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChartTableView } from './BiChartTableView';
import { BiChartView } from './BiChartView';
import { BiFunnelView } from './BiFunnelView';
import { BiKpiGroupView } from './BiKpiGroupView';
import { BiKpiView } from './BiKpiView';
import { BiTableView } from './BiTableView';
import { BiViewMode } from './functions/biViewMode';

export const kBiEmptyResultText = '这段时间内没有符合条件的数据。';

export const BiVisualizationBody = memo(
  ({
    viz,
    result,
    compact,
    view = BiViewMode.Chart,
    palette,
    chartHeight,
    fill,
    inlineCopy,
  }: {
    viz: BiVizSpec;
    result: BiDraftResult;
    /** A short dashboard card: a KPI drops its label and its box. */
    compact?: boolean;
    /** A chart shown as its result table; ignored by a table or a KPI. */
    view?: BiViewMode;
    /** The dashboard's palette; a chat draft uses the default. */
    palette?: BiPalette;
    /** The plot's height, e.g. taller on the card page. */
    chartHeight?: number;
    /** A chart takes the height its fixed-size container leaves it. */
    fill?: boolean;
    /** False where the container offers a table's 复制数据 itself. */
    inlineCopy?: boolean;
  }) => {
    if (result.current.rows.length === 0)
      return <CardNotice text={kBiEmptyResultText} />;
    switch (viz.type) {
      case BiVizType.Table:
        return (
          <BiTableView
            viz={viz}
            result={result.current}
            inlineCopy={inlineCopy}
          />
        );
      case BiVizType.Kpi:
        return <BiKpiView viz={viz} result={result} compact={compact} />;
      case BiVizType.KpiGroup:
        return view === BiViewMode.Table ? (
          <BiChartTableView
            viz={viz}
            result={result.current}
            inlineCopy={inlineCopy}
          />
        ) : (
          <BiKpiGroupView viz={viz} result={result} palette={palette} />
        );
      case BiVizType.Funnel:
        return view === BiViewMode.Table ? (
          <BiChartTableView
            viz={viz}
            result={result.current}
            inlineCopy={inlineCopy}
          />
        ) : (
          <BiFunnelView viz={viz} result={result.current} palette={palette} />
        );
      default:
        return view === BiViewMode.Table ? (
          <BiChartTableView
            viz={viz}
            result={result.current}
            inlineCopy={inlineCopy}
          />
        ) : (
          <BiChartView
            viz={viz}
            result={result.current}
            palette={palette}
            height={chartHeight}
            fill={fill}
          />
        );
    }
  },
);
